import { render, staticRenderFns } from "./NewCountry.vue?vue&type=template&id=701e62e4&scoped=true&"
import script from "./NewCountry.vue?vue&type=script&lang=js&"
export * from "./NewCountry.vue?vue&type=script&lang=js&"
import style0 from "./NewCountry.vue?vue&type=style&index=0&id=701e62e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701e62e4",
  null
  
)

export default component.exports